import styled from 'styled-components';

export const Wrap = styled.div`
    max-width: 900px;
    margin: 0 auto;
    padding: 20px;
    @media(max-width: 767px){ padding: 10px 12px; }
`;

export const Titulo = styled.h1`
    text-align: center;
    color: var(--jk-text);
    font-size: 26px;
    font-weight: bold;
    margin: 24px 0 8px 0;
    @media(max-width: 767px){ font-size: 22px; margin: 10px 0 6px 0; }
`;

export const Subtitulo = styled.p`
    text-align: center;
    color: var(--jk-text);
    opacity: 0.8;
    margin-bottom: 24px;
`;

export const Grade = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    justify-content: center;
`;

export const CartaoMundo = styled.div`
    background: var(--white-color);
    border: 3px solid ${(p) => p.cor || '#4FA3E3'};
    border-radius: 20px;
    padding: 24px;
    width: 260px;
    text-align: center;
    cursor: pointer;
    transition: transform 0.2s ease;
    box-shadow: var(--elev-1);
    &:hover { transform: translateY(-5px); }
`;

export const EmojiGrande = styled.div`
    font-size: 56px;
    line-height: 1.1;
`;

export const SeloMundo = styled.img`
    width: 120px;
    height: 120px;
    object-fit: contain;
`;

export const SeloPequeno = styled.img`
    width: 40px;
    height: 40px;
    object-fit: contain;
    vertical-align: middle;
    margin-right: 8px;
`;

export const VersoCarta = styled.img`
    width: 82%;
    height: 82%;
    object-fit: contain;
`;

export const NomeMundo = styled.div`
    font-size: 20px;
    font-weight: bold;
    color: var(--jk-text);
    margin: 8px 0 4px 0;
`;

export const InfoMundo = styled.div`
    font-size: 14px;
    color: var(--jk-text);
    opacity: 0.75;
`;

export const LinhaFases = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;
    max-width: 460px;
    margin: 0 auto;
`;

export const BotaoFase = styled.button`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
    padding: 16px 20px;
    font-size: 18px;
    font-weight: bold;
    color: ${(p) => (p.bloqueada ? '#999' : 'var(--jk-text)')};
    background: ${(p) => (p.bloqueada ? '#eee' : 'var(--white-color)')};
    border: 3px solid ${(p) => (p.bloqueada ? '#ddd' : p.cor || '#4FA3E3')};
    border-radius: 16px;
    cursor: ${(p) => (p.bloqueada ? 'not-allowed' : 'pointer')};
    box-shadow: var(--elev-1);
    transition: transform 0.15s ease;
    &:hover { transform: ${(p) => (p.bloqueada ? 'none' : 'translateY(-3px)')}; }
`;

export const BotaoVoltar = styled.button`
    display: inline-block;
    margin: 4px 0 16px 0;
    padding: 8px 16px;
    min-height: 44px;
    font-size: 15px;
    border: none;
    border-radius: 12px;
    background: #eef2f6;
    color: var(--jk-text);
    cursor: pointer;
    touch-action: manipulation;
    @media(max-width: 767px){ margin: 2px 0 8px 0; }
`;

export const CartaoJogo = styled.div`
    background: var(--white-color);
    border-radius: 20px;
    box-shadow: var(--elev-2);
    padding: 24px;
    max-width: 560px;
    margin: 0 auto;
    text-align: center;
    @media(max-width: 767px){ padding: 14px; }
`;

export const ImagemFlash = styled.img`
    /* Proporcional à ALTURA da tela: o card inteiro (imagem + palavra +
       botões) cabe sem precisar rolar, no celular e no computador. */
    width: min(230px, 58vw, 24vh);
    height: auto;
    border-radius: 16px;
`;

export const PalavraGrande = styled.div`
    font-size: 34px;
    font-weight: bold;
    color: var(--jk-text);
    margin-top: 6px;
    @media(max-width: 767px){ font-size: 28px; }
`;

export const Traducao = styled.div`
    font-size: 18px;
    color: var(--jk-text);
    opacity: 0.75;
    margin-bottom: 10px;
`;

export const BotaoSom = styled.button`
    font-size: 22px;
    padding: 10px 22px;
    min-height: 48px;
    border: none;
    border-radius: 50px;
    background: ${(p) => p.cor || '#4FA3E3'};
    color: white;
    cursor: pointer;
    touch-action: manipulation;
    margin: 4px 0 10px 0;
    transition: transform 0.15s ease;
    &:hover { transform: scale(1.06); }
    &:active { transform: scale(0.97); }
`;

export const BotaoPrincipal = styled.button`
    font-size: 18px;
    font-weight: bold;
    padding: 14px 30px;
    min-height: 52px;
    border: none;
    border-radius: 50px;
    background: ${(p) => p.cor || '#4FA3E3'};
    color: white;
    cursor: pointer;
    touch-action: manipulation;
    margin-top: 6px;
    transition: transform 0.15s ease;
    &:hover { transform: scale(1.04); }
    &:active { transform: scale(0.97); }
`;

export const GradeMemoria = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    max-width: 480px;
    margin: 12px auto;
    @media(max-width: 480px) {
        grid-template-columns: repeat(2, 1fr);
    }
`;

export const CartaMemoria = styled.button`
    aspect-ratio: 1 / 1;
    border-radius: 14px;
    border: 3px solid ${(p) => (p.acertada ? '#5cb85c' : p.cor || '#4FA3E3')};
    background: var(--white-color);
    font-size: 15px;
    font-weight: bold;
    color: var(--jk-text);
    cursor: pointer;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    opacity: ${(p) => (p.acertada ? 0.85 : 1)};
    img { width: 100%; height: 100%; object-fit: contain; }
`;

export const GradeQuiz = styled.div`
    display: flex;
    gap: 12px;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 14px;
`;

export const OpcaoQuiz = styled.button`
    width: 140px;
    border-radius: 16px;
    border: 4px solid ${(p) => (p.errada ? '#e05555' : 'transparent')};
    background: var(--white-color);
    box-shadow: var(--elev-1);
    cursor: pointer;
    padding: 6px;
    transition: transform 0.15s ease;
    &:hover { transform: scale(1.05); }
    img { width: 100%; border-radius: 12px; }
`;

export const EstrelasGrandes = styled.div`
    font-size: 52px;
    letter-spacing: 6px;
    margin: 12px 0;
`;

export const BarraProgresso = styled.div`
    font-size: 15px;
    color: var(--jk-text);
    opacity: 0.7;
    margin-bottom: 10px;
`;

/* ---------- Fase B: barra do topo (sequência, moedas, botões) ---------- */
export const BarraTopo = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin: 8px auto 20px auto;
`;

export const Selo = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: var(--white-color);
    border: 2px solid ${(p) => p.cor || '#ffd54f'};
    border-radius: 50px;
    padding: 8px 16px;
    font-weight: bold;
    color: var(--jk-text);
    box-shadow: var(--elev-1);
`;

export const BotaoTopo = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: ${(p) => p.cor || '#7C5CFC'};
    color: white;
    border: none;
    border-radius: 50px;
    padding: 9px 18px;
    font-weight: bold;
    font-size: 15px;
    cursor: pointer;
    box-shadow: var(--elev-1);
    transition: transform 0.15s ease;
    &:hover { transform: translateY(-2px); }
`;

/* ---------- Álbum de figurinhas ---------- */
export const GradeAlbum = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    max-width: 620px;
    margin: 0 auto;
    @media(max-width: 560px) { grid-template-columns: repeat(2, 1fr); }
`;

export const SlotFigurinha = styled.div`
    background: var(--white-color);
    border-radius: 18px;
    box-shadow: var(--elev-1);
    padding: 12px;
    text-align: center;
    opacity: ${(p) => (p.tem ? 1 : 0.75)};
    img {
        width: 100%;
        aspect-ratio: 1/1;
        object-fit: contain;
        filter: ${(p) => (p.tem ? 'none' : 'grayscale(1) opacity(0.35)')};
    }
`;

export const NomeFigurinha = styled.div`
    font-size: 13px;
    font-weight: bold;
    color: var(--jk-text);
    margin-top: 6px;
`;

export const DicaFigurinha = styled.div`
    font-size: 12px;
    color: var(--jk-text);
    opacity: 0.7;
`;

/* ---------- Missões de conversa ---------- */
export const CartaoMissao = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;
    background: var(--white-color);
    border: 3px solid ${(p) => (p.feita ? '#5cb85c' : p.cor || '#4FA3E3')};
    border-radius: 18px;
    padding: 16px 20px;
    max-width: 560px;
    margin: 0 auto 14px auto;
    box-shadow: var(--elev-1);
    cursor: ${(p) => (p.feita ? 'default' : 'pointer')};
    transition: transform 0.15s ease;
    &:hover { transform: ${(p) => (p.feita ? 'none' : 'translateY(-3px)')}; }
`;

export const MissaoTexto = styled.div`
    flex: 1;
    text-align: left;
    font-size: 16px;
    font-weight: 600;
    color: var(--jk-text);
`;

export const MissaoRecompensa = styled.div`
    font-size: 13px;
    color: #b8860b;
    font-weight: bold;
`;

/* ---------- Complete a palavra ---------- */
export const LetrasAlvo = styled.div`
    display: flex;
    gap: 8px;
    justify-content: center;
    margin: 16px 0;
    flex-wrap: wrap;
`;

export const CaixaLetra = styled.div`
    width: 46px;
    height: 56px;
    border-radius: 12px;
    border: 3px dashed ${(p) => (p.preenchida ? 'transparent' : '#bbb')};
    background: ${(p) => (p.preenchida ? (p.cor || '#4FA3E3') : '#f4f6f8')};
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 26px;
    font-weight: bold;
    text-transform: uppercase;
`;

export const LetrasOpcoes = styled.div`
    display: flex;
    gap: 10px;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 8px;
`;

export const TeclaLetra = styled.button`
    width: 48px;
    height: 48px;
    border-radius: 12px;
    border: none;
    background: var(--white-color);
    box-shadow: var(--elev-1);
    font-size: 22px;
    font-weight: bold;
    text-transform: uppercase;
    color: var(--jk-text);
    cursor: pointer;
    visibility: ${(p) => (p.usada ? 'hidden' : 'visible')};
    transition: transform 0.12s ease;
    &:hover { transform: scale(1.08); }
`;

/* ---------- Confete + pop-up de figurinha nova ---------- */
export const Confete = styled.div`
    position: fixed;
    top: -10px;
    left: ${(p) => p.x}%;
    font-size: ${(p) => p.tam}px;
    pointer-events: none;
    z-index: 9998;
    animation: cai 2.4s linear forwards;
    animation-delay: ${(p) => p.atraso}s;
    @keyframes cai {
        to { transform: translateY(110vh) rotate(540deg); opacity: 0.9; }
    }
`;

export const Fundo = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    padding: 20px;
`;

export const PopFigurinha = styled.div`
    background: var(--white-color);
    border-radius: 24px;
    padding: 24px 28px;
    text-align: center;
    max-width: 340px;
    box-shadow: var(--elev-2);
    img { width: 200px; max-width: 60vw; }
`;
